import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import BaseApi from "../../utils/BaseApi";
import OverheadPeriodicCreate from "./OverheadPeriodicCreate";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";


class OverheadPeriodicList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            overheads: [],
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveOverheads();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveOverheads();
        }
    }

    async retrieveOverheads() {
        this.setState(
            {
                overheads: null,
            }
        );
        const url = 'overhead/';
        const api = new BaseApi();
        let params = {
            periodic: true,
            ordering: '-date_start_publish'
        }
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                overheads: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    async delete(id) {
        const url = `overhead/${id}/`;
        const api = new BaseApi();
        await api.delete(url);
        await this.retrieveOverheads()
    }

    render() {
        if (!this.state.overheads) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Накладные расходы - периодические'}
                    url={'financial/overhead_periodic'}
                    data={this.state.overheads}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    callBack={this.retrieveOverheads.bind(this)}
                    extraComponents={[
                        {
                            component: OverheadPeriodicCreate,
                            componentProps: {
                                callBack: this.retrieveOverheads.bind(this)
                            }
                        },
                    ]}
                    fields={[

                        {
                            title: 'Заголовок',
                            name: 'title',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['title', ],
                                baseUrl: 'overhead',
                            },
                        },
                        {
                            title: 'Категория',
                            name: 'category.title',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['category', ],
                                baseUrl: 'overhead',
                                obj: {
                                    id: 'id',
                                    category: 'category.id'
                                }
                            },
                        },
                        {
                            title: 'Сумма',
                            name: 'cost',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['cost', ],
                                baseUrl: 'overhead',
                            },
                        },
                        {
                            title: 'Дата выплаты',
                            name: 'pay_date',
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):'Не указано'),
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['pay_date', ],
                                baseUrl: 'overhead',
                            },
                        },
                        {
                            title: 'Период',
                            name: 'period_human',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['period', ],
                                baseUrl: 'overhead',
                            },
                        },
                        {
                            title: 'Дата начала',
                            name: 'date_start_publish',
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):'Не указано'),
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['date_start_publish', ],
                                baseUrl: 'overhead',
                            },
                        },
                        {
                            title: 'Дата окончания',
                            name: 'date_end_publish',
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):'Не указано'),
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['date_end_publish', ],
                                baseUrl: 'overhead',
                            },
                        },

                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.delete.bind(this),
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(OverheadPeriodicList)
